import { motion } from "framer-motion";
import { Check, ArrowUpRight } from "@phosphor-icons/react";
import { useLang } from "@/lib/LangContext";

const PRODUCT_IMAGES = [
  "https://images.unsplash.com/photo-1680992046626-418f7e910589?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwxfHxzZXJ2ZXIlMjByb29tJTIwbmVvbiUyMGxpZ2h0c3xlbnwwfHx8fDE3ODM3MTgxMTZ8MA&ixlib=rb-4.1.0&q=85",
];

export const Products = () => {
  const { t } = useLang();
  return (
    <section
      id="products"
      data-testid="products-section"
      className="relative py-24 lg:py-32 border-b border-white/10"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="mb-16 max-w-3xl">
          <p className="font-mono-x text-xs tracking-[0.3em] text-brand-500 font-bold">
            {t.products.overline}
          </p>
          <h2 className="mt-4 font-display font-medium tracking-tighter text-white text-4xl sm:text-5xl lg:text-6xl">
            {t.products.title}
          </h2>
          <p className="mt-6 font-mono-x text-sm sm:text-base text-slate-300 leading-relaxed">
            {t.products.description}
          </p>
        </div>
        <div className="grid grid-cols-1 max-w-[450px] gap-px bg-white/10 border border-white/10">
          {t.products.items.map((p, i) => (
            <motion.article
              key={i}
              data-testid={`product-card-${i}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className="beam-border group relative bg-black hover:bg-slate-950/60 transition-colors duration-300 flex flex-col"
            >
              <div className="relative overflow-hidden aspect-[16/10] border-b border-white/10">
                <img
                  src={PRODUCT_IMAGES[i]}
                  alt={p.title}
                  className="w-full h-full object-cover opacity-40 group-hover:opacity-70 transition-opacity duration-500"
                />
                <div className="absolute top-4 left-4 font-mono-x text-[10px] tracking-[0.25em] text-brand-500 bg-black/70 px-2 py-1 border border-brand-500/40">
                  {p.tag}
                </div>
              </div>
              <div className="p-8 flex flex-col flex-1">
                <h3 className="font-display text-2xl sm:text-3xl text-white tracking-tight">
                  {p.title}
                </h3>
                <p className="mt-4 font-mono-x text-sm text-slate-300 leading-relaxed">
                  {p.description}
                </p>
                <ul className="mt-6 space-y-2 flex-1">
                  {p.bullets.map((b, j) => (
                    <li
                      key={j}
                      className="flex items-center gap-3 font-mono-x text-xs text-slate-200"
                    >
                      <Check
                        size={14}
                        weight="bold"
                        className="text-brand-500 flex-shrink-0"
                      />
                      {b}
                    </li>
                  ))}
                </ul>
                <a
                  data-testid={`product-cta-${i}`}
                  href={p.url || "#contact"}
                  target={p.url ? "_blank" : undefined}
                  rel={p.url ? "noopener noreferrer" : undefined}
                  className="mt-8 group/link inline-flex items-center gap-2 text-white border-b border-white/20 pb-2 self-start font-mono-x text-xs uppercase tracking-widest hover:border-brand-500 hover:text-brand-500 transition-colors duration-200"
                >
                  {p.cta}
                  <ArrowUpRight
                    size={14}
                    className="group-hover/link:translate-x-1 group-hover/link:-translate-y-1 transition-transform duration-200"
                  />
                </a>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};
